module.exports = __webpack_public_path__ + "static/media/Oxford Road Developments 4 Inc - HCRA Compliance Order - February 26- 2025.31056788.pdf";